class ProductBundleForm extends HTMLElement {
  constructor() {
    super();

    this.variantButtons = this.querySelectorAll('[data-variant-id]');
    this.maxBundleQuantity = this.querySelector('[data-pack-bundle].active')?.getAttribute('data-pack-bundle') || 0;
    this.currentBundleQuantity = 0;
    this.selectedVariantId = this.querySelector('[data-variant-id].active')?.getAttribute('data-variant-id');
    this.bundleComponentsArray = [];

    this.addToCartButton = this.querySelector('.product-form__submit');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    this.errorAmountElement = this.querySelector('.product-bundle-components__error-text');
    this.errorAmountText = this.errorAmountElement?.querySelector('.error-amount');

    this.quickBuyBanner = this.closest('.product')?.querySelector('bundle-quick-buy-banner');
    this.bannerErrorAmountElement = this.quickBuyBanner?.querySelector('.product-bundle-components__error-text');
    this.bannerErrorAmountText = this.bannerErrorAmountElement?.querySelector('.error-amount');
    this.bannerAddToCartButton = this.quickBuyBanner?.querySelector('.product-form__submit');
  }

  connectedCallback() {
    this.variantButtons.forEach(variantButton => {
      variantButton.addEventListener('click', () => {
        this.changeVariant(variantButton);
      })
    })

    this.addEventListener('change', this.validateQuantity.bind(this))

    this.addToCartButton?.addEventListener('click', this.addToCart.bind(this));
  }

  changeVariant(variantButton) {
    this.maxBundleQuantity = variantButton.getAttribute('data-pack-bundle');
    this.selectedVariantId = variantButton.getAttribute('data-variant-id');
    this.variantButtons.forEach(variantButton => {
      variantButton.classList.remove('active');
    })

    variantButton.classList.add('active');
    this.validateQuantity();
  }

  validateQuantity() {
    this.currentBundleQuantity = this.bundleComponentsArray.reduce((accumulator, component) => {
      return accumulator + Number(component.quantity);
    }, 0);

    const itemsCountToReach = (this.maxBundleQuantity - this.currentBundleQuantity)
    const isQuantityLimitReached = this.currentBundleQuantity == +this.maxBundleQuantity
    const isQuantityLimitExceed = itemsCountToReach < 0;
    
    this.addToCartButton.toggleAttribute('disabled', !isQuantityLimitReached);
    this.errorAmountElement?.classList.toggle('hidden', isQuantityLimitReached);
    this.errorAmountElement?.classList.toggle('error-text--limit-reached', isQuantityLimitExceed)
    this.errorAmountText.innerText = isQuantityLimitExceed ? Math.abs(itemsCountToReach) : itemsCountToReach;

    if (this.quickBuyBanner) {
      this.bannerAddToCartButton.toggleAttribute('disabled', !isQuantityLimitReached);
      this.bannerErrorAmountElement?.classList.toggle('hidden', isQuantityLimitReached);
      this.bannerErrorAmountElement?.classList.toggle('error-text--limit-reached', isQuantityLimitExceed)
      this.bannerErrorAmountText.innerText = isQuantityLimitExceed ? Math.abs(itemsCountToReach) : itemsCountToReach;
    }

    const isSoldOutProduct = this.addToCartButton.classList.contains('product-form__submit--out-of-stock');
    if (isSoldOutProduct) this.addToCartButton.disabled = true;

    return isQuantityLimitReached;
  }

  addToCart() {
    if (!this.selectedVariantId || !this.validateQuantity()) return;

    document.dispatchEvent(new Event('theme:loading:start'))

    const bundleComponentsString = this.bundleComponentsArray.map(item => `${item.id}:${item.quantity}`).join(',');
    const data = {
      'items': [
        {
          'id': Number(this.selectedVariantId),
          'quantity': 1,
          'properties': {
            _bundleComponents: bundleComponentsString
          }
        }
      ],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    };

    if(localStorage.getItem('first-visited-page')){
      data.items[0].properties = data.items[0].properties || {};
      data.items[0].properties['_first_visited_page'] = localStorage.getItem('first-visited-page');
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then((response) => {
      this.cart.renderContents(response);
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      document.dispatchEvent(new Event('theme:loading:end'));
    });
  }
}

if (!customElements.get('product-bundle-form')) {
  customElements.define('product-bundle-form', ProductBundleForm)
}

class ProductBundleComponent extends ProductBundleForm {
  constructor() {
    super();

    this.componentId = this.getAttribute('data-component-id');
    this.quantityInput = this.querySelector('.component-item-quantity__value');
    this.increaseButton = this.querySelector('.component-item-quantity__increase');
    this.decreaseButton = this.querySelector('.component-item-quantity__decrease');
    this.productBundleForm = this.closest('product-bundle-form');
  }

  connectedCallback() {
    this.increaseButton?.addEventListener('click', this.increaseQuantity.bind(this));
    this.decreaseButton?.addEventListener('click', this.decreaseQuantity.bind(this));
    this.addEventListener('click', (event) => {
      this.toggleQuantity(event);
    })
  }

  increaseQuantity() {
    const {currentBundleQuantity, maxBundleQuantity} = this.productBundleForm;
    const itemsCountToReach = maxBundleQuantity - currentBundleQuantity;
    const isQuantityLimitReached = +currentBundleQuantity === +maxBundleQuantity;
    const isQuantityLimitExceed = itemsCountToReach < 0;
    if (isQuantityLimitReached || isQuantityLimitExceed) return;
    
    this.quantityInput.value++
    this.onQuantityChange();
    this.quantityInput?.dispatchEvent(new Event('change', {bubbles: true}));
  }

  decreaseQuantity() {
    if (this.quantityInput.value == 0) return;
    this.quantityInput.value--
    this.onQuantityChange();
    this.quantityInput?.dispatchEvent(new Event('change', {bubbles: true}));
  }

  toggleQuantity(event) {
    if (this.quantityInput.value > 1) return;
    if (this.increaseButton?.contains(event.target) || this.decreaseButton?.contains(event.target)) return;

    if (this.quantityInput.value == 0) {
      this.increaseQuantity();
    } else {
      this.decreaseQuantity();
    }
  }

  onQuantityChange() {
    const quantity = Number(this.quantityInput.value);
    const componentItemIndexInComponentsArray = this.productBundleForm.bundleComponentsArray.findIndex(component => component.id == this.componentId);
    const hasQuantity = quantity > 0;

    if (componentItemIndexInComponentsArray != -1 && quantity > 0) {
      this.productBundleForm.bundleComponentsArray[componentItemIndexInComponentsArray].quantity = quantity;
    } else if (componentItemIndexInComponentsArray == -1 && quantity > 0) {
      this.productBundleForm.bundleComponentsArray.push({
        id: this.componentId,
        quantity: quantity
      })
    } else if (componentItemIndexInComponentsArray != -1 && quantity <= 0) {
      this.productBundleForm.bundleComponentsArray.splice(componentItemIndexInComponentsArray, 1);
    }

    this.classList.toggle('bundle-components-item--active', hasQuantity)
  }
}

if (!customElements.get('product-bundle-component')) {
  customElements.define('product-bundle-component', ProductBundleComponent);
}

if (!customElements.get('bundle-quick-buy-banner')) {
  customElements.define(
    'bundle-quick-buy-banner',
    class BundleQuickBuyBanner extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.product-form__submit');
        this.addToCartButton = this.closest('.product')?.querySelector('product-bundle-form .product-form__submit');
      }

      connectedCallback() {
        window.addEventListener('scroll', this.toggleSubscriptionBar)
        this.button.addEventListener('click', (event) => this.onButtonClick(event))
      }

      toggleSubscriptionBar() {
        const subscriptionSection = document.querySelector('.product__section');
        const buyButtons = subscriptionSection?.querySelector('.product-steps__add-to-cart'); 

        if (subscriptionSection && buyButtons) {
          var windowOffset = window.scrollY;
          var sectionHeight = buyButtons.clientHeight;
          var sectionOffset = buyButtons.offsetTop;
          sectionOffset = sectionOffset + sectionHeight - 60;
          
          if (windowOffset <= sectionOffset && windowOffset > 150) {
            document.body.classList.add('subscription-bar-open');
          } else {
            document.body.classList.remove('subscription-bar-open');
          }
        }
      }

      onButtonClick(event) {
        event.preventDefault();
        if (!this.addToCartButton) return;
        
        this.addToCartButton.click();
      }
    }
  )
}